import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=2622f304&scoped=true&"
import script from "./businessList.vue?vue&type=script&lang=js&"
export * from "./businessList.vue?vue&type=script&lang=js&"
import style0 from "./businessList.vue?vue&type=style&index=0&id=2622f304&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622f304",
  null
  
)

export default component.exports